import React, { useState, useEffect } from "react"
import { useNavigate } from "react-router"
import useTitle from "@/hooks/useTitle"
import EtBtnFormBasic from "@/components/common/buttons/EtBtnFormBasic"
import PulseLoader from "react-spinners/PulseLoader"

// 08 Sep 2026
import EtContentEditorLight2
  from "@/utils/EtContentEditorLight2"

import {
  useGetOrgIntentionBoardsQuery,
  useUpdateOrgIntentionBoardMutation,
} from "@/features/orgIntentionBoards/orgIntentionBoardsApiSlice"

import {
  useGetOrganizationsQuery,
} from "@/pages/admin/organizations/organizationsApiSlice"

import EtOrgIntentionQuestionManager
  from "./EtOrgIntentionQuestionManager"

import EtOrgIntentionCandidateManager
  from "./EtOrgIntentionCandidateManager"

// 07 Sep 2026
import EtOrgIntentionResponseBoard
  from "@/features/orgIntentionBoards/EtOrgIntentionResponseBoard"

import EtOrgIntentionCandidateReviewBoard
  from "@/features/orgIntentionBoards/EtOrgIntentionCandidateReviewBoard"

// 09 Sep 2026
import EtOrgIntentionBoardResponsePreview
  from "@/features/orgIntentionBoards/EtOrgIntentionBoardResponsePreview"

const EtUpdateOrgIntentionBoard = ({
  id,
  setActiveAdminView,
}) => {

  // First Created - 04 Sep 2026
  // Author - Atul Pandey
  // Purpose - To update a Trinity Intention Board.
  // Updated - 04 Sep 2026 - Added Board Setup and Questions tabs.
  // Updated - 07 Sep 2026 - Added Response Review tab
  // Updated - 07 Sep 2026 - Added Candidate Review & Decision tab
  // Updated - 08 Sep 2026 -  Rich text editor refinement.
  // Updated - 09 Sep 2026 -  Response Board Rreview Tab

  // Debug
  // console.log('inside EtUpdateOrgIntentionBoard...')
  // console.log('id', id)

  useTitle("Update Intention Board")

  /*
  |--------------------------------------------------------------------------
  | 1 - State
  |--------------------------------------------------------------------------
  */

  const [
    activeTab,
    setActiveTab,
  ] =
    useState(
      "board"
    )

  /*
  |--------------------------------------------------------------------------
  | 2 - Get Intention Board
  |--------------------------------------------------------------------------
  */

  const {
    orgIntentionBoard,
  } =
    useGetOrgIntentionBoardsQuery(
      undefined,
      {
        selectFromResult:
          ({
            data,
          }) => ({

            orgIntentionBoard:
              data
                ?.entities[id],

          }),
      }
    )

  // console.log('orgIntentionBoard', orgIntentionBoard)

  /*
  |--------------------------------------------------------------------------
  | 3 - Loading
  |--------------------------------------------------------------------------
  */

  if (
    !orgIntentionBoard
  ) {

    return (
      <PulseLoader
        color={"#ea580c"}
      />
    )

  }

  /*
  |--------------------------------------------------------------------------
  | 4 - Render
  |--------------------------------------------------------------------------
  */

  return (

    <div className="bg-gray-200 p-1 mx-auto mt-5 rounded-lg shadow-md shadow-black">

      {/* Tabs */}

      <div className="bg-white m-1 p-1 rounded">

        <div className="flex justify-start items-center border-b border-gray-200">

          {/* Board Setup */}

          <div
            onClick={
              () =>
                setActiveTab(
                  "board"
                )
            }
            className={`cursor-pointer px-4 py-2 text-xs font-bold ${
              activeTab ===
              "board"
                ? "text-orange-700 border-b-2 border-orange-600 bg-orange-50"
                : "text-gray-600 hover:bg-gray-100"
            }`}
          >
            Board Setup
          </div>

          {/* Response Board Preview  - 09 Sep 2026*/}

          <div
            onClick={
              () =>
                setActiveTab(
                  "preview"
                )
            }
            className={`cursor-pointer px-4 py-2 text-xs font-bold ${
              activeTab ===
              "preview"
                ? "text-orange-700 border-b-2 border-orange-600 bg-orange-50"
                : "text-gray-600 hover:bg-gray-100"
            }`}
          >
            Preview
          </div>

          {/* Questions */}

          <div
            onClick={
              () =>
                setActiveTab(
                  "questions"
                )
            }
            className={`cursor-pointer px-4 py-2 text-xs font-bold ${
              activeTab ===
              "questions"
                ? "text-orange-700 border-b-2 border-orange-600 bg-orange-50"
                : "text-gray-600 hover:bg-gray-100"
            }`}
          >
            Questions
          </div>

          {/* Candidates */}
          <div
            onClick={
                () =>
                setActiveTab(
                    "candidates"
                )
            }
            className={`cursor-pointer px-4 py-2 text-xs font-bold ${
                activeTab ===
                "candidates"
                ? "text-orange-700 border-b-2 border-orange-600 bg-orange-50"
                : "text-gray-600 hover:bg-gray-100"
            }`}
            >
            Candidates
          </div>

          {/* Responses - 07 Sep 2026 */}
          <div
            onClick={
                () =>
                setActiveTab(
                    "responses"
                )
            }
            className={`cursor-pointer px-4 py-2 text-xs font-bold ${
                activeTab ===
                "responses"
                ? "text-orange-700 border-b-2 border-orange-600 bg-orange-50"
                : "text-gray-600 hover:bg-gray-100"
            }`}
            >
            Responses
          </div>

          {/* Reviews & Decisions - 07 Sep 2026 */}
          <div
            onClick={
                () =>
                setActiveTab(
                    "reviews"
                )
            }
            className={`cursor-pointer px-4 py-2 text-xs font-bold ${
                activeTab ===
                "reviews"
                ? "text-orange-700 border-b-2 border-orange-600 bg-orange-50"
                : "text-gray-600 hover:bg-gray-100"
            }`}
            >
            Reviews & Decisions
          </div>


        </div>

      </div>

      {/* Board Setup */}

      {activeTab ===
        "board" && (

        <EtUpdateOrgIntentionBoardForm
          orgIntentionBoard={
            orgIntentionBoard
          }
          id={
            id
          }
          setActiveAdminView={
            setActiveAdminView
          }
        />

      )}

      {/* Response Board Preview  09 Sep 2026*/}

      {activeTab ===
        "preview" && (

        <div className="m-1 p-1">

          <EtOrgIntentionBoardResponsePreview
            board={
              orgIntentionBoard
            }
          />

        </div>

      )}

      {/* Questions */}

      {activeTab ===
        "questions" && (

        <div className="m-1 p-1">

          <EtOrgIntentionQuestionManager
            intentionBoardId={
              id
            }
          />

        </div>

      )}

      {/* Candidates */}
      {activeTab ===
        "candidates" && (

        <div className="m-1 p-1">

            <EtOrgIntentionCandidateManager
            intentionBoardId={
                id
            }
            />

        </div>

       )}

      {/* Responses - 07 Sep 2026 */}
      {activeTab ===
        "responses" && (

        <EtOrgIntentionResponseBoard
            intentionBoardId={
            id
            }
        />

      )}

      {/* Reviews & Decisions - 07 Sep 2026 */}
      {activeTab ===
        "reviews" && (

        <EtOrgIntentionCandidateReviewBoard
            intentionBoardId={
            id
            }
        />

      )}

    </div>

  )

}


/*
|--------------------------------------------------------------------------
| Update Intention Board Form
|--------------------------------------------------------------------------
*/

const EtUpdateOrgIntentionBoardForm = ({
  orgIntentionBoard,
  id,
  setActiveAdminView,
}) => {

  // First Created - 04 Sep 2026
  // Author - Atul Pandey
  // Purpose - Update form for Trinity Intention Board.
  // Updated - 08 Sep 2026 -  Rich text editor refinement.

  const navigate =
    useNavigate()

  /*
  |--------------------------------------------------------------------------
  | 1 - Update Mutation
  |--------------------------------------------------------------------------
  */

  const [
    updateOrgIntentionBoard,
    {
      isLoading,
      isSuccess,
      isError,
      error,
    },
  ] =
    useUpdateOrgIntentionBoardMutation()

  /*
  |--------------------------------------------------------------------------
  | 2 - Get Organizations
  |--------------------------------------------------------------------------
  */

  const {
    data:
      organizationsData,

    isLoading:
      isLoadingOrganizations,

    isError:
      isOrganizationsError,

    error:
      organizationsError,

  } =
    useGetOrganizationsQuery()

  /*
  |--------------------------------------------------------------------------
  | 3 - Normalize Organizations
  |--------------------------------------------------------------------------
  */

  const organizations =
    organizationsData
      ?.ids
      ?.map(
        organizationId =>
          organizationsData
            ?.entities[
              organizationId
            ]
      ) ||
    []

  /*
|--------------------------------------------------------------------------
| 4 - Format Date For datetime-local
|--------------------------------------------------------------------------
|
| Backend stores the response deadline as UTC.
|
| datetime-local must display the wall clock date / time belonging
| to the Intention Board timezone, not the browser timezone.
|
| Example:
|
| Stored UTC:
| 2026-09-28T16:29:00.000Z
|
| Board timezone:
| Asia/Kolkata
|
| datetime-local:
| 2026-09-28T21:59
|
*/

const formatDateTimeLocal =
  (
    dateValue,
    timezone
  ) => {

    if (
      !dateValue
    ) {

      return ""

    }

    const boardTimezone =
      timezone ||
      "America/Los_Angeles"

    const date =
      new Date(
        dateValue
      )

    const parts =
      new Intl.DateTimeFormat(
        "en-US",
        {
          timeZone:
            boardTimezone,

          year:
            "numeric",

          month:
            "2-digit",

          day:
            "2-digit",

          hour:
            "2-digit",

          minute:
            "2-digit",

          hourCycle:
            "h23",
        }
      )
        .formatToParts(
          date
        )

    const getPart =
      type =>
        parts.find(
          part =>
            part.type ===
            type
        )
          ?.value ||
        ""

    return (
      `${getPart("year")}-` +
      `${getPart("month")}-` +
      `${getPart("day")}T` +
      `${getPart("hour")}:` +
      `${getPart("minute")}`
    )

  }

  /*
  |--------------------------------------------------------------------------
  | 5 - Form State
  |--------------------------------------------------------------------------
  */

  const [
    formData,
    setFormData,
  ] =
    useState({

      orgId:
        orgIntentionBoard
          ?.orgId
          ?._id ||
        orgIntentionBoard
          ?.orgId ||
        "",

      trailId:
        orgIntentionBoard
          ?.trailId
          ?._id ||
        orgIntentionBoard
          ?.trailId ||
        "",

      boardName:
        orgIntentionBoard
          ?.boardName ||
        "",

      publicSlug:
        orgIntentionBoard
          ?.publicSlug ||
        "",

      orgCode:
        orgIntentionBoard
          ?.orgCode ||
        "",

      passcode:
        "",

      headline:
        orgIntentionBoard
          ?.headline ||
        "",

      boardNarrative:
        orgIntentionBoard
          ?.boardNarrative ||
        "",

      closingNarrative:
        orgIntentionBoard
          ?.closingNarrative ||
        "",

      responseDeadline:
        formatDateTimeLocal(
            orgIntentionBoard
            ?.responseDeadline,
            orgIntentionBoard
            ?.timezone
        ),
      timezone:
        orgIntentionBoard
          ?.timezone ||
        "America/Los_Angeles",

      boardStatus:
        orgIntentionBoard
          ?.boardStatus ||
        "draft",

      isActive:
        orgIntentionBoard
          ?.isActive ??
        true,

      allowLateResponses:
        orgIntentionBoard
          ?.allowLateResponses ??
        false,

      invitationEmailSubject:
        orgIntentionBoard
          ?.invitationEmailSubject ||
        "",

      invitationEmailBody:
        orgIntentionBoard
          ?.invitationEmailBody ||
        "",

    })

  /*
  |--------------------------------------------------------------------------
  | 6 - Success
  |--------------------------------------------------------------------------
  */

  useEffect(() => {

    if (
      isSuccess
    ) {

      if (
        setActiveAdminView
      ) {

        setActiveAdminView(
          "orgIntentionBoards"
        )

      } else {

        navigate(
          "/orgIntentionBoards"
        )

      }

    }

  }, [isSuccess])

  /*
  |--------------------------------------------------------------------------
  | 7 - Handle Change
  |--------------------------------------------------------------------------
  */

  const handleChange =
    e => {

      const {
        name,
        value,
        type,
        checked,
      } =
        e.target

      if (
        type ===
        "checkbox"
      ) {

        setFormData(
          prevState => ({

            ...prevState,

            [name]:
              checked,

          })
        )

      } else {

        setFormData(
          prevState => ({

            ...prevState,

            [name]:
              value,

          })
        )

      }

    }

/*
|--------------------------------------------------------------------------
| Board Narrative Change - 08 Sep 2026
|--------------------------------------------------------------------------
*/

const handleBoardNarrativeChange =
  value => {

    setFormData(
      prevState => ({

        ...prevState,

        boardNarrative:
          value,

      })
    )

  }

  /*
  |--------------------------------------------------------------------------
  | 8 - Handle Submit
  |--------------------------------------------------------------------------
  */

  const handleSubmit =
    async e => {

      e.preventDefault()

      const intentionBoardData = {

        intentionBoardId:
          id,

        orgId:
          formData.orgId,

        trailId:
          formData.trailId ||
          null,

        boardName:
          formData.boardName,

        publicSlug:
          formData.publicSlug,

        orgCode:
          formData.orgCode,

        headline:
          formData.headline,

        boardNarrative:
          formData.boardNarrative,

        closingNarrative:
          formData.closingNarrative,

        responseDeadline:
          formData.responseDeadline,

        timezone:
          formData.timezone,

        boardStatus:
          formData.boardStatus,

        isActive:
          formData.isActive,

        allowLateResponses:
          formData.allowLateResponses,

        invitationEmailSubject:
          formData.invitationEmailSubject,

        invitationEmailBody:
          formData.invitationEmailBody,

      }

      /*
      |--------------------------------------------------------------------------
      | Passcode
      |--------------------------------------------------------------------------
      |
      | Only send when changed.
      |
      */

      if (
        formData.passcode
      ) {

        intentionBoardData.passcode =
          formData.passcode

      }

      try {

        await updateOrgIntentionBoard(
          intentionBoardData
        )
          .unwrap()

      } catch (
        error
      ) {

        console.error(
          error
        )

      }

    }

  /*
  |--------------------------------------------------------------------------
  | 9 - Handle Cancel
  |--------------------------------------------------------------------------
  */

  const handleCancel =
    () => {

      if (
        setActiveAdminView
      ) {

        setActiveAdminView(
          "orgIntentionBoards"
        )

      } else {

        navigate(
          "/orgIntentionBoards"
        )

      }

    }

  /*
  |--------------------------------------------------------------------------
  | 10 - Render
  |--------------------------------------------------------------------------
  */

  return (

    <div className="bg-gray-200 p-1 mx-auto mt-5 rounded-lg shadow-md shadow-black">

      {/* Loading */}

      {isLoading && (

        <PulseLoader
          color={"#ea580c"}
        />

      )}

      {isLoadingOrganizations && (

        <PulseLoader
          color={"#ea580c"}
          size={6}
        />

      )}

      {/* Errors */}

      {isError && (

        <p className="text-orange-700 font-semi-bold py-2">
          {error?.data?.message}
        </p>

      )}

      {isOrganizationsError && (

        <p className="text-orange-700 font-semi-bold py-2">

          {
            organizationsError
              ?.data
              ?.message ||
            "Error loading organizations"
          }

        </p>

      )}

      <div className="bg-white p-1 m-1 rounded">

        <p className="p-1 m-1 font-bold font-poppins text-xl">
          Update Intention Board
        </p>

        <div className="bg-gray-200 rounded m-1 p-1">

          <form
            onSubmit={handleSubmit}
            className="m-1 p-1 text-xs font-poppins"
          >

            {/* Organization */}

            <div id="orgId">

              <select
                name="orgId"
                value={formData.orgId}
                onChange={handleChange}
                className="w-full rounded p-2 m-1"
              >

                <option value="">
                  Select Organization
                </option>

                {organizations
                  ?.filter(
                    organization =>
                      organization
                        ?.active !==
                      false
                  )
                  ?.sort(
                    (
                      a,
                      b
                    ) =>
                      (
                        a
                          ?.organizationName ||
                        ""
                      )
                        .localeCompare(
                          b
                            ?.organizationName ||
                          ""
                        )
                  )
                  ?.map(
                    organization => (

                      <option
                        key={
                          organization
                            ?._id
                        }
                        value={
                          organization
                            ?._id
                        }
                      >

                        {
                          organization
                            ?.organizationName
                        }

                      </option>

                    )
                  )}

              </select>

              <p className="text-[9px] text-gray-500 mx-2 px-2">
                Organization associated with this Intention Board.
              </p>

            </div>

            {/* Trail */}

            <div id="trailId">

              <input
                type="text"
                name="trailId"
                placeholder="Enter Trail ID, if applicable"
                value={formData.trailId}
                onChange={handleChange}
                className="w-full rounded p-2 m-1"
              />

              <p className="text-[9px] text-gray-500 mx-2 px-2">
                Optional. Leave blank if this Intention Board is not linked
                to a specific Trinity Trail.
              </p>

            </div>

            {/* Board Name */}

            <div id="boardName">

              <input
                type="text"
                name="boardName"
                placeholder="Enter the Intention Board name"
                value={formData.boardName}
                onChange={handleChange}
                className="w-full rounded p-2 m-1"
              />

            </div>

            {/* Public Slug */}

            <div id="publicSlug">

              <input
                type="text"
                name="publicSlug"
                placeholder="Enter public slug"
                value={formData.publicSlug}
                onChange={handleChange}
                className="w-full rounded p-2 m-1"
              />

              <p className="text-[9px] text-gray-500 mx-2 px-2">
                Public URL: {window.location.origin}/trinity/intention/{formData.publicSlug}
              </p>

            </div>

            {/* Organization Code */}

            <div id="orgCode">

              <input
                type="text"
                name="orgCode"
                placeholder="Enter organization access code"
                value={formData.orgCode}
                onChange={handleChange}
                className="w-full rounded p-2 m-1"
              />

            </div>

            {/* Passcode */}

            <div id="passcode">

              <input
                type="text"
                name="passcode"
                placeholder="Enter a new passcode only if you want to change it"
                value={formData.passcode}
                onChange={handleChange}
                className="w-full rounded p-2 m-1"
              />

              <p className="text-[9px] text-gray-500 mx-2 px-2">
                Leave blank to keep the existing passcode.
              </p>

            </div>

            {/* Headline */}

            <div id="headline">

              <input
                type="text"
                name="headline"
                placeholder="Enter Intention Board headline"
                value={formData.headline}
                onChange={handleChange}
                className="w-full rounded p-2 m-1"
              />

            </div>

            {/*
            |--------------------------------------------------------------------------
            | Board Narrative - Before You Begin
            |--------------------------------------------------------------------------
            */}

            <div
            id="boardNarrative"
            className="m-1 p-1"
            >

            <p className="font-bold text-xs mx-1 mb-2">
                Before You Begin
            </p>

            <EtContentEditorLight2
                editorKey={
                `updateOrgIntentionBoardNarrative-${id}`
                }
                value={
                formData
                    .boardNarrative
                }
                handleChange={
                handleBoardNarrativeChange
                }
                placeholderText={
                "Enter the opening narrative for nominated leaders..."
                }
            />

            </div>

            {/* Board Narrative */}

            {/* <div id="boardNarrative">

              <textarea
                name="boardNarrative"
                placeholder="Enter the opening narrative for nominated leaders"
                value={formData.boardNarrative}
                onChange={handleChange}
                className="w-full rounded p-2 m-1"
                rows={6}
              />

            </div> */}

            {/* Closing Narrative */}

            <div id="closingNarrative">

              <textarea
                name="closingNarrative"
                placeholder="Enter the closing narrative shown after the Intention Board"
                value={formData.closingNarrative}
                onChange={handleChange}
                className="w-full rounded p-2 m-1"
                rows={4}
              />

            </div>

            {/* Response Deadline */}

            <div
              id="responseDeadline"
              className="m-1 p-1"
            >

              <p className="font-bold mx-1 mb-1">
                Response Deadline
              </p>

              <input
                type="datetime-local"
                name="responseDeadline"
                value={formData.responseDeadline}
                onChange={handleChange}
                className="w-full rounded p-2"
              />

            </div>

            {/* Timezone */}

            <div id="timezone">

              <select
                name="timezone"
                value={formData.timezone}
                onChange={handleChange}
                className="w-full rounded p-2 m-1"
              >

                <option value="America/Los_Angeles">
                  US Pacific
                </option>

                <option value="America/Denver">
                  US Mountain
                </option>

                <option value="America/Chicago">
                  US Central
                </option>

                <option value="America/New_York">
                  US Eastern
                </option>

                <option value="Europe/London">
                  UK
                </option>

                <option value="Asia/Kolkata">
                  India
                </option>

              </select>

              <p className="text-[9px] text-gray-500 mx-2 px-2">
                The response deadline will be interpreted in this timezone.
              </p>

            </div>

            {/* Board Status */}

            <div id="boardStatus">

              <select
                name="boardStatus"
                value={formData.boardStatus}
                onChange={handleChange}
                className="w-full rounded p-2 m-1"
              >

                <option value="draft">
                  Draft
                </option>

                <option value="open">
                  Open
                </option>

                <option value="closed">
                  Closed
                </option>

                <option value="archived">
                  Archived
                </option>

              </select>

            </div>

            {/* Board Controls */}

            <div className="m-1 p-2 bg-white rounded">

              <div className="flex justify-start items-center">

                <input
                  type="checkbox"
                  name="isActive"
                  checked={formData.isActive}
                  onChange={handleChange}
                  className="m-1"
                />

                <p className="text-xs font-bold text-gray-700 m-1">
                  Active Intention Board
                </p>

              </div>

              <div className="flex justify-start items-center">

                <input
                  type="checkbox"
                  name="allowLateResponses"
                  checked={formData.allowLateResponses}
                  onChange={handleChange}
                  className="m-1"
                />

                <p className="text-xs font-bold text-gray-700 m-1">
                  Allow Responses After Deadline
                </p>

              </div>

            </div>

            {/* Invitation Email Subject */}

            <div id="invitationEmailSubject">

              <input
                type="text"
                name="invitationEmailSubject"
                placeholder="Invitation email subject"
                value={formData.invitationEmailSubject}
                onChange={handleChange}
                className="w-full rounded p-2 m-1"
              />

            </div>

            {/* Invitation Email Body */}

            <div id="invitationEmailBody">

              <textarea
                name="invitationEmailBody"
                placeholder="Invitation email body"
                value={formData.invitationEmailBody}
                onChange={handleChange}
                className="w-full rounded p-2 m-1"
                rows={5}
              />

            </div>

            {/* Actions */}

            <div
              id="actions"
              className="bg-white m-1 px-1 py-3 rounded"
            >

              <EtBtnFormBasic
                name={"Update"}
                type={"create"}
                handleClick={handleSubmit}
                disabled={
                  isLoading ||
                  isLoadingOrganizations ||
                  !formData.orgId
                }
              />

              <EtBtnFormBasic
                name={"Cancel"}
                type={"cancel"}
                handleClick={handleCancel}
              />

            </div>

          </form>

        </div>

      </div>

    </div>

  )

}

export default EtUpdateOrgIntentionBoard